<!-- =========================================================================================
    File Name: SettingsEdit.vue
    Description: Edit Settings
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">

        <h4> Edit Settings details </h4> <br/>        

        <div class="p-6">
                        
            <form @submit.prevent="submitForm">

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span>Settings Name</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <h4> {{ SettingsName }} </h4>
                    </div>
                </div>

                <div class="vx-row" v-if="SettingsId >= 1 && SettingsId <= 3">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span> Settings alue </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <v-select v-model="LedgerId" name="LedgerId" :value="LedgerId" :options="LedgerIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required'" > </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('LedgerId')">{{ errors.first('LedgerId') }}</span>
                    </div>
                </div>

                <div class="vx-row" v-if="SettingsId == 4">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span> Settings value </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <vs-input class="w-full" v-model="SettingsValue" v-validate="'required'" name="SettingsValue" />
                        <span class="text-danger text-sm" v-show="errors.has('SettingsValue')">{{ errors.first('SettingsValue') }}</span>
                    </div>
                </div>

                <div class="vx-row" v-if="SettingsId == 6">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span> Settings value </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <datepicker placeholder="StartDate" v-validate="'required'" v-model="StartDate"></datepicker>
                        <span class="text-danger text-sm" v-show="errors.has('StartDate')">{{ errors.first('StartDate') }}</span>
                    </div>
                </div>

                <div class="vx-row" v-if="SettingsId == 7">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span> Settings value </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <v-select v-model="CompanyRegistrationId" name="CompanyRegistrationId" :value="CompanyRegistrationId" :options="CompanyRegistrationIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                        <span class="text-danger text-sm" v-show="errors.has('CompanyRegistrationId')">{{ errors.first('CompanyRegistrationId') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full text-right mb-3">
                        <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                    </div>
                </div>                

            </form>
        </div>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';

const dict = {    
    custom: {        
        LedgerId: { required : 'Ledger should not be empty', },
        StartDate: { required : 'Financial Year Start Date should not be empty', },
        CompanyRegistrationId: { required : 'Company Registration should not be empty', },
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    mixins: [common],
    components: {
        'v-select': vSelect,
        Datepicker
    },    
    props: {
        editRecordPrompt: {
            type: Boolean,
            required: true,
        },
        recordIndex: {
            type: Number,
            required: true,
        }        
    },    
    data() {
        return {
            // activePrompt: false,

            SettingsCompanyId: this.$store.state.companySettings.dataArray[this.recordIndex].SettingsCompanyId,
            SettingsValuesId: this.$store.state.companySettings.dataArray[this.recordIndex].SettingsValuesId,
            SettingsId: this.$store.state.companySettings.dataArray[this.recordIndex].SettingsId,
            SettingsName: this.$store.state.companySettings.dataArray[this.recordIndex].SettingsName,
            SettingsValue: this.$store.state.companySettings.dataArray[this.recordIndex].SettingsValue,

            LedgerId: this.$store.state.companySettings.dataArray[this.recordIndex].SettingsValue,
            StartDate: this.$store.state.companySettings.dataArray[this.recordIndex].SettingsValue,
            CompanyRegistrationId: this.$store.state.companySettings.dataArray[this.recordIndex].SettingsValue,

            LedgerIdOptions: [],
            CompanyRegistrationIdOptions: [],

        }
    },
    computed: {
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideEditRecordPrompt');
        },
        updateRecordDetails() {

            var SettingsValue = this.SettingsValue;
            var SettingsId = this.SettingsId;

            // Set Ledger Id

            if (SettingsId >= 1 && SettingsId <= 3) {
                SettingsValue = this.LedgerId;
            }

            // Set Financial Year Start Date

            if (SettingsId == 6) {
                SettingsValue = this.StartDate;
            }

            // Set Company RC

            if (SettingsId == 7) {
                SettingsValue = this.CompanyRegistrationId;
            }

            // check Settings value
            
            if (SettingsValue != "") {

                var recordObj = {
                    "SettingsValue" :  SettingsValue, 
                };

                var server_url=companyConfig.apiURL;
                var record={};
                record.token=this.$session.get('token');
                record.update_url=server_url+'lib/api/settings/update';
                record.where={ 
                    "settings_values_company_info_id" :  this.SettingsCompanyId, 
                    "settings_values_id" :  this.SettingsValuesId, 
                    "settings_values_settings_id" :  SettingsId,
                };
                record.form=recordObj;
                record.list_url=server_url+'lib/api/settings/lists';
                record.list_where={};
                console.log('record='+JSON.stringify(record));
                record.loading=this.$vs.loading;
                record.notify=this.$vs.notify;
                record.http=this.$http;                        
                this.$store.dispatch('companySettings/updateRecordDetails', record);

                this.closePrompt();
                
            } else {
                var message="Settings Value should not be empty";
                this.errorMessage(message);
            }

        },
        init() {

            // clear all fileds
            
            this.$parent.editRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.updateRecordDetails();
            })
        }
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            // Load Ledger Id Dropdown

            var selectbox1_source = 'LedgerId'
            var selectbox1_destination = 'LedgerIdOptions'
            var selectbox1_url = 'lib/api/data/get_ledger_options'
            var selectbox1_conditions_array = {
                'ledger_details_ledger_category_id >=': 6,
                'ledger_details_ledger_category_id <=': 8,
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url);

            // Load Company Registration Dropdown

            var selectbox2_source = 'CompanyRegistrationId'
            var selectbox2_destination = 'CompanyRegistrationIdOptions'
            var selectbox2_url = 'lib/api/data/get_company_registration_options'
            var selectbox2_conditions_array = {
                'where': {},
                'or_where': {}
            }
            this.getSelectBoxOptions(selectbox2_source, selectbox2_destination, selectbox2_conditions_array, selectbox2_url);
        }
    }    
}
</script>
<style>
  .con-vs-popup .vs-popup {
    width: 800px;
  }
</style>